/**
 * @flow
 */
import React from "react";
import {ROUTE} from '../../settings'
import Nav from '../../services/Nav'
import PrimaryButton from '../../components/ui/PrimaryButton'
import _404 from '../../media/404.svg';

const NotFound = () => {
  return (
    <div className="flex flex-center flex-middle w-100 h-100vh">
      <div className="flex flex-column flex-center flex-middle" style={{maxWidth: "320px"}}>
        {/*<img className="mb-32" src={process.env.NODE_ENV === 'production' ? '/dboard/assets/images/illustrations/404.svg' : '/assets/images/illustrations/404.svg'} alt="" />*/}
        <img src={_404} alt={'404'} />
        <PrimaryButton label={'Back to Dashboard'} onClick={() => Nav.push(ROUTE.INDEX)}/>
      </div>
    </div>
  );
};

export default NotFound;
